export default __webpack_public_path__ + "static/media/logo.1e3be4a3.svg";